import { render, staticRenderFns } from "./SingleCompanyProducts.vue?vue&type=template&id=cd537e5e&"
import script from "./SingleCompanyProducts.vue?vue&type=script&lang=js&"
export * from "./SingleCompanyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports